<template>
    <span :class="`error-inline${' ' + wrapperClass}`" v-if="typeof type == 'string' && errors.has(type)">{{ translatedError(type, errors.first(type)) }}</span>
    <ul :class="`error-inline-list${' ' + wrapperClass}`" v-else-if="typeof type == 'object'">
        <li class="error-inline" v-for="(item, ind) in type" :key="ind" v-if="errors.has(item)">
            {{ translatedError(item, errors.first(item)) }}
        </li>
    </ul>
</template>

<script>
export default {
    name: 'InlineError',
    methods: {
        translatedError(type, error) {
            // Conditions:
            // - Phone handles itself as it has the phone placeholder number.
            if (type !== 'mobile') {
                return this.$gettext(error);
            } else {
                return error;
            }
        }
    },
    props: {
        errors: {
            type: Object
        },
        type: {
            type: [String, Array],
            required: true
        },
        wrapperClass: {
            type: String,
            default: ''
        }
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Forms/InlineError.vue